
import React, { useEffect, useState } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $createInlineFrameNode, InlineFrameNode } from "../nodes/InlineFrameNode";
import { $getSelection, $insertNodes, $isRangeSelection, COMMAND_PRIORITY_EDITOR, createCommand, type LexicalCommand } from "lexical";
import ModalWithFinalForm from "../../modals/ModalWithFinalForm";
import { Row } from "reactstrap";
import FormFieldTextOrNumber from "../../formFields/FormFieldTextOrNumber";
import { useIntl } from "react-intl";

export const INSERT_MEDIA_COMMAND: LexicalCommand<string> = createCommand();

export default function MediaPlugin(): JSX.Element | null
{
    const intl = useIntl();
    const [editor] = useLexicalComposerContext();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [mediaAddress, setMediaAddress] = useState('');
    const handleOnSubmit = (formData: any) =>
    {
        const mediaAddress = formData?.mediaAddress;
        if (mediaAddress)
        {
            editor.update(() =>
            {
                const node = $createInlineFrameNode({ src: mediaAddress });
                const selection = $getSelection();
                if ($isRangeSelection(selection)) { $insertNodes([node]); }
            });
            setIsModalOpen(false);
        }
    };
    useEffect(() =>
    {
        if (!editor.hasNodes([InlineFrameNode]))
        {
            throw new Error('InlineFrameNode not registered on editor');
        }
        const handleCommand = (payload: string) =>
        {
            setMediaAddress(payload);
            setIsModalOpen(true);
            return true;
        };
        return editor.registerCommand<string>(INSERT_MEDIA_COMMAND, handleCommand, COMMAND_PRIORITY_EDITOR);
    },
    [editor]);
    const translations = (intl as any).messages?.sharedComponents?.lexicalEditor?.iframeModal;
    const header = translations?.header ?? 'External media';
    const confirm = translations?.confirm ?? 'OK';
    const cancel = translations?.cancel ?? 'Cancel';
    const address = translations?.address ?? 'Media address';
    const buttons =
    {
        confirm: { color: 'success', label: confirm },
        cancel: { color: 'danger', label: cancel }
    };
    const body =
    <>
        {/* <Alert color='danger' isOpen={isAlertOpen} toggle={() => setIsAlertOpen(false)} >
            <span>{alertMessage}</span>
        </Alert> */}
        <Row className='my-2'>
            <FormFieldTextOrNumber type='text' className="w-100" name='mediaAddress' label={address} />
        </Row>
    </>;
    const form = <ModalWithFinalForm isOpen={isModalOpen} initialValues={{ mediaAddress: mediaAddress }}
        setIsOpen={setIsModalOpen}
        onConfirm={handleOnSubmit}
        header={header}
        buttons={buttons}
        modalBody={body}
    />;
    return form;
}
